// The team's storage in the query cache (spec web/usage-pill-storage): the header's usage pill
// reads it, and each write of this tab that keeps or drops a team file (the library's, a voice's,
// an actor's) reads it again through this one function, as live's `useRefreshStorageUsage`.
import type { QueryClient } from "@tanstack/react-query";

import { getGetTeamStorageQueryKey } from "./generated/endpoints/assets/assets";

/** Reads the team's storage again, so the header's pill shows the GB its files hold now. */
export function refreshTeamStorage(queryClient: QueryClient, teamId: string): Promise<void> {
  return queryClient.invalidateQueries({ queryKey: getGetTeamStorageQueryKey(teamId) });
}
